import { z } from 'zod';
import { SignalCategorySchema } from '@terra/shared-schemas-orchestrator';

export const BoothApplicationIdParamsSchema = z.object({
  applicationId: z.string(),
});

export const BoothVaultPublicOriginBodySchema = z.object({
  vaultPublicOrigin: z.string().min(1),
});

export const BoothApplicationScopedMutationInputSchema = z.object({
  params: BoothApplicationIdParamsSchema,
  body: BoothVaultPublicOriginBodySchema.optional(),
});

export const BoothApplicationResetResponseSchema = z.object({
  findingsDeleted: z.number(),
  signalsDeleted: z.number(),
  endpointsDeleted: z.number(),
  executionsDeleted: z.number(),
  durationMs: z.number(),
});

export const BoothVaultSeedKeySchema = z.enum([
  'maintenance',
  'customer-idor',
  'vault-notes',
]);

export const BoothEnsureSignalSeedsResponseSchema = z.object({
  createdCount: z.number(),
  expectedSignals: z.number(),
  harEntriesEnsured: z.number(),
  endpointsLinked: z.number(),
  assetLinks: z.array(
    z.object({
      seedKey: BoothVaultSeedKeySchema,
      endpointId: z.string(),
      harEntryId: z.string(),
    }),
  ),
});

export const BoothSignalSeedSchema = z.object({
  seedKey: BoothVaultSeedKeySchema,
  description: z.string().min(1),
  category: SignalCategorySchema,
  analysis: z.string().optional(),
});

export type BoothApplicationResetResponse = z.infer<
  typeof BoothApplicationResetResponseSchema
>;
export type BoothEnsureSignalSeedsResponse = z.infer<
  typeof BoothEnsureSignalSeedsResponseSchema
>;
export type BoothSignalSeed = z.infer<typeof BoothSignalSeedSchema>;
export type BoothVaultSeedKey = z.infer<typeof BoothVaultSeedKeySchema>;
export type BoothVaultPublicOriginBody = z.infer<
  typeof BoothVaultPublicOriginBodySchema
>;
